import styled from '@emotion/styled';

export const FormGroup = styled('div')`
  margin: 1.5rem 0;
  i {
    margin: 0.25rem 0 0 0.5rem;
    cursor: pointer;
  }
`;
